import { useState, useEffect } from "react";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import { useParams, useNavigate } from 'react-router-dom';
import { Thuthuat1, Thuthuat2, Thuthuat3, Thuthuat4, Thuthuat5, Thuthuat6, Thuthuat7, Thuthuat8, valueThuThuat } from "./DetailThuThuatData";
import { subtractCoinsForCurrentUser } from "../../utilities/axios.utilities";
import Swal from "sweetalert2";

const DetailThuthuat = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCoinSubtraction = async () => {
      try {
        const thuthuatNumber = id?.replace('thuthuat', '');
        const thuthuat = valueThuThuat.find(t => t.link === `/thuthuat${thuthuatNumber}`);
        
        if (!thuthuat) {
          navigate('/trickBacarat');
          return;
        }

        await subtractCoinsForCurrentUser(thuthuat.coin);
        setIsLoading(false);
      } catch (error: any) {
        console.error("Error subtracting coins:", error);
        Swal.fire({
          title: 'Lỗi',
          text: error.response?.status === 400 ? 'Không đủ xu để xem thủ thuật này' : 'Có lỗi xảy ra, vui lòng thử lại sau',
          icon: 'error',
          confirmButtonText: 'Đóng',
          confirmButtonColor: '#d33',
          background: '#000000bd',
          color: '#fff',
          customClass: {
            popup: 'swal2-popup',
            title: 'swal2-title',
            htmlContainer: 'swal2-content',
            confirmButton: 'swal2-confirm',
          }
        }).then(() => {
          navigate('/trickBacarat');
        });
      }
    };

    handleCoinSubtraction();
  }, [id, navigate]);

  const renderThuthuat = () => {
    const thuthuatNumber = id?.replace('thuthuat', '');

    switch (thuthuatNumber) {
      case '1':
        return <Thuthuat1 />;
      case '2':
        return <Thuthuat2 />;
      case '3':
        return <Thuthuat3 />;
      case '4':
        return <Thuthuat4 />;
      case '5':
        return <Thuthuat5 />;
      case '6':
        return <Thuthuat6 />;
      case '7':
        return <Thuthuat7 />;
      case '8':
        return <Thuthuat8 />;
      default:
        return <div>Không tìm thấy thủ thuật</div>;
    }
  };

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-8 rounded-lg text-center">
          <h2 className="text-2xl font-bold mb-4">Đang xử lý...</h2>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      <div className="container-fluid lobby-bg position-relative  mx-auto  mb-5 max-w-screen-xl">
        <div className="container mx-auto">
          <div className="flex flex-wrap my-7">
            <div className="w-1/2 md:w-2/3">
            </div>
            <div className="w-1/2 md:w-1/3 flex justify-center items-center">
              <a href="/trickBacarat" className="text-white no-underline">
                <div className="text-white px-4 py-2 rounded-lg shadow box-goto-lobby w-[10rem]">
                  Quay lại
                </div>
              </a>
            </div>
          </div>
          <div>
            {renderThuthuat()}
          </div>
        </div>
      </div>
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </div>
  );
};

export default DetailThuthuat;
